module.exports = {
  path: '/registeReview',
  name: 'registeReview',
  meta: { title: '报名审核', icon: 'el-icon-upload' },
  component: () => import('../views/registeReview/registeReview.vue')
}
